module.exports = __webpack_public_path__ + "static/media/Raw.edb035ec.jpg";